import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap";

const TampilEntryRacikan = () => {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(tempUrl + "/entryRacikans/" + id, {
        _id: user.id,
        token: user.token,
      });
      setData(response.data);
    } catch (error) {
      alert(error.response?.data?.message || error.message);
    }
    setLoading(false);
  };

  const deleteData = async () => {
    if (!window.confirm("Yakin ingin menghapus Entry Racikan ini?")) return;
    try {
      await axios.post(tempUrl + "/deleteEntryRacikan/" + id, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      navigate("/daftarEntryRacikan");
    } catch (error) {
      alert(error.response?.data?.message || error.message);
    }
  };

  if (loading) return <Loader />;
  if (!data) return null;

  return (
    <Container fluid className="py-3 px-2 px-md-4">
      <div className="text-secondary small">Transaksi</div>
      <h3 className="fw-bold mb-3">Detail Entry Racikan</h3>
      <div className="d-flex gap-2 mb-3">
        <Button size="sm" variant="outline-secondary" onClick={() => navigate("/daftarEntryRacikan")}>Kembali</Button>
        <Button size="sm" variant="primary" onClick={() => navigate("/daftarEntryRacikan/entryRacikan/" + id + "/edit")}>Ubah</Button>
        <Button size="sm" variant="danger" onClick={deleteData}>Hapus</Button>
      </div>

      <Card className="border-0 shadow-sm mb-3">
        <Card.Header className="bg-primary text-white fw-semibold py-2">Informasi Transaksi</Card.Header>
        <Card.Body className="p-3">
          <Row className="g-2 small">
            <Col xs={12} md={4}><b>No. Bukti</b><div>{data.noBukti}</div></Col>
            <Col xs={12} md={4}><b>Tanggal</b><div>{data.tanggal}</div></Col>
            <Col xs={12} md={4}><b>COA</b><div>{data.coa ? data.coa.kodeCOA + " - " + data.coa.namaCOA : "-"}</div></Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-primary text-white fw-semibold py-2">Detail Racikan</Card.Header>
        <Card.Body className="p-2 p-md-3">
          {(data.children || []).map((child, index) => (
            <Card key={child.id} className="border mb-3">
              <Card.Header className="bg-light py-2 small fw-semibold">
                Racikan #{index + 1} — {child.stok ? child.stok.kodeStok + " - " + child.stok.namaStok : "-"}
                <span className="float-end">Quantity: {child.quantity}</span>
              </Card.Header>
              <Card.Body className="p-2">
                <Table responsive bordered hover size="sm" className="align-middle mb-0">
                  <thead className="table-light"><tr><th>Stok Item</th><th className="text-end">Quantity / Unit</th><th className="text-end">Quantity Total</th></tr></thead>
                  <tbody>
                    {(child.items || []).map((item) => (
                      <tr key={item.id}>
                        <td className="small">{item.stok ? item.stok.kodeStok + " - " + item.stok.namaStok : "-"}</td>
                        <td className="text-end">{item.quantity}</td>
                        <td className="text-end fw-semibold">{item.quantityTotal}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          ))}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilEntryRacikan;
